<template>
    <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3">
        <div class="p-3 flex content-main gap-5 pb-[70px]">

            <div class="custom-full">
                <Nav />


                <template v-if="can_manage_compliance_settings">

                    <template v-if="vg_selectedLocation.id">

                        <div class="bg-[#2B2C32] rounded-lg px-8 mt-1 pb-3">
                            <div class=" flex justify-between  h-[50px] items-center pt-2">
                                <h1 class="text-white font-semibold text-[24px]">Marketplace</h1>
                                <button v-if="!loading" @click.prevent="save()" :class="'bg-white text-theme-green hover:bg-theme-darkgreen rounded  mt-2 px-4 py-2 '"><span
                                        class="text-sm tracking-widest font-medium">SAVE</span></button>
                            </div>

                            <block-loading v-if="loading"/>

                            <div class="flex gap-3 flex-row w-full items-start mb-3" v-else>


                                <div class="w-2/4">
                                    <div :class="'input-wrapper ' + (form.integrationValue.error_type)">  
                                        <label class="text-xs mb-1 font-normal">Leafly Dispensary Menu API Key</label>
                                        <input @keyup="validateFields(['integrationValue'])" v-model="form.integrationValue.value" placeholder="[Key example]" type="text"
                                            class="block rounded bg-gray-black border-none w-full text-sm text-theme-white">
                                            <p class="field-error label-text mt-1" v-if="form.integrationValue.error_message" v-text="form.integrationValue.error_message"></p>
                                    </div>
                                </div>
                                <div class="w-2/4 mt-[13px]">
                                    <button :disabled="!haveData" v-if="!loading" @click.prevent="syncMenu()" :class="(!haveData ? 'bg-theme-grey text-slatewhite' : 'bg-white text-theme-green hover:bg-theme-darkgreen' ) + ' rounded  mt-2 px-4 py-2 '"><span
                                        class="text-sm tracking-widest font-medium">Sync</span></button>
                                </div>
                            
                            </div>


                        </div>

                    </template>

                    <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
                        <p class="text-center text-theme-red mt-3">Please select a location from the top left corner.</p>
                    </div>

                </template>

                <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
                    <p class="text-center text-theme-red mt-3">Page is restricted.</p>
                </div>

              

                
            </div>

        </div>

    </div>
</template>


<script lang="ts">
    import {
        defineComponent,
        ref
    } from "vue"
    import {
        mapGetters,
        mapActions,
        mapMutations
    } from "vuex";
    import Nav from '@/views/Location/Integrations/Nav.vue';
    import LocationIntegrationApis from "@/controllers/LocationIntegrationApis";
    import Helpers from '@/helpers';
    import { useSnackbar } from "vue3-snackbar";
    import router from '@/router';

    export default defineComponent({
        name: "LocationIntregationIndex",
        components: {
            Nav,
        },

        setup() {
            const loading = ref(false);
            const haveData = ref(false)
            const form:any = ref({
                integrationProvider: {
                    value: 'leafly',
                    error_type: '',
                    error_message: '',
                    validations: ['required'],
                },
                integrationKey: {
                    value: 'leafly',
                    error_type: '',
                    error_message: '',
                    validations: ['required'],
                },
                integrationValue: {
                    value: '',
                    error_type: '',
                    error_message: '',
                    validations: ['required'],
                },
            });
            const snackbar = useSnackbar();

            return {
                snackbar,
                form,
                loading,
                haveData
            };
        },

        watch: {
            'vg_selectedLocation'(val) {
              if(this.vg_userToken){
                this.fetchData();
              }else{
                router.push('/login?sessionExpired=1')
              }
            },
        },

        computed: {
            ...mapGetters({
                vg_selectedLocation: 'location/selected',
                vg_userToken: 'auth/userToken',
                vg_user: 'auth/user',
            }),

            can_manage_compliance_settings() {
                return Helpers.getMyPermission('can_manage_compliance_settings');
            },

        },

        mounted() {
            this.fetchData();
        },

        beforeDestroy() {

        },

        methods: {

             /**
             * Validation captures
             */
            async validateFields(fields) {
                let res = await Helpers.validateFormFields(this.form, fields);
                // capture the fields
                this.form = res.data;
                return res.error ? false : true;
            },
            
            /**
             * Save data
             */
             async fetchData() {
                this.loading = true;
                let res = await LocationIntegrationApis.fetchAll(this.vg_selectedLocation.id, 'leafly');  
                if(res.status == 200) {
                    this.form = Helpers.assignFormValues(this.form, res.data.payload[0]);
                    this.haveData = true
                } else {
                    this.form = Helpers.resetFormValue(this.form)
                    this.form.integrationProvider.value = 'leafly'
                    this.form.integrationKey.value = 'ApiKey'
                    this.haveData = false
                }
                this.loading = false;
            },

            /**
             * Save data
             */
            async save() {
                let validate = await this.validateFields(['integrationProvider', 'integrationKey', 'integrationValue']);
                if(!validate) {
                    return ;
                }

                this.va_spinner(true);
                let res = await LocationIntegrationApis.create(Helpers.getFormKeyValue(this.form));
                this.va_spinner(false);
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                this.fetchData()
            },

            async syncMenu(){
                this.va_spinner(true);
                let res = await LocationIntegrationApis.sync(this.vg_selectedLocation.id);
                this.va_spinner(false);
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
            },

            ...mapActions({
                va_spinner: 'spinner/setSpinner',
            })
        },
    });
</script>